(function () {
  function money(c) { return '$' + (c / 100).toFixed(2); }
  var drawer, overlay;
  function openDrawer() { if (drawer) drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); }
  function updateBadge(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = n; b.style.display = n > 0 ? '' : 'none';
    });
  }
  function renderCart(cart) {
    var items = document.querySelector('[data-cart-items]');
    var foot = document.querySelector('[data-cart-foot]');
    var title = document.querySelector('[data-cart-title]');
    if (title) title.textContent = 'Your Cart' + (cart.item_count > 0 ? ' (' + cart.item_count + ')' : '');
    if (!items) return;
    if (cart.item_count === 0) {
      items.innerHTML = '<div class="em-empty"><p style="font-size:15px">Your cart is empty.</p><button class="em-btn" type="button" data-cart-close>Continue shopping</button></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (it, idx) {
      var line = idx + 1;
      html += '<div class="em-li">' +
        (it.image ? '<img src="' + it.image + '" alt="">' : '') +
        '<div class="em-li-info">' +
          '<div class="nm">' + it.product_title + '</div>' +
          '<div style="font-size:13px;color:var(--ink-soft)">' + money(it.price) + '</div>' +
          '<div class="em-qty">' +
            '<button type="button" data-qty data-line="' + line + '" data-q="' + (it.quantity - 1) + '">&ndash;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-qty data-line="' + line + '" data-q="' + (it.quantity + 1) + '">+</button>' +
          '</div>' +
          '<button class="em-rm" type="button" data-qty data-line="' + line + '" data-q="0">Remove</button>' +
        '</div>' +
        '<div style="font-weight:500;font-size:14px;color:var(--accent);font-family:var(--disp)">' + money(it.line_price) + '</div>' +
      '</div>';
    });
    items.innerHTML = html;
    if (foot) {
      foot.style.display = '';
      var s = foot.querySelector('[data-cart-subtotal]');
      if (s) s.textContent = money(cart.total_price);
      var co = foot.querySelector('[data-checkout]');
      if (co) co.textContent = 'Checkout \u00b7 ' + money(cart.total_price);
    }
  }
  function refresh() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); updateBadge(c.item_count); return c; });
  }
  function renderCartFromCart(cart) { renderCart(cart); updateBadge(cart.item_count); }
  function change(line, q) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(q, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartFromCart);
  }
  function reveal() {
    var els = document.querySelectorAll('.em-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: if anything is still hidden after 1.2s (e.g. inside an editor
    // iframe where the observer never fires), just show it.
    setTimeout(function () {
      document.querySelectorAll('.em-reveal:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('in');
      });
    }, 1200);
  }
  function init() {
    document.body.classList.add('ember-js');
    drawer = document.querySelector('.em-drawer');
    overlay = document.querySelector('.em-overlay');
    reveal();
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { var n = document.querySelector('.em-mnav'); if (n) n.classList.toggle('open'); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('em-overlay')) { closeDrawer(); return; }
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-variant-id');
      if (!id) return;
      var o = add.textContent;
      add.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          add.textContent = 'Added \u2713';
          setTimeout(function () { add.textContent = o; }, 1300);
          refresh().then(openDrawer);
        })
        .catch(function () { add.textContent = o; });
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) { change(q.getAttribute('data-line'), q.getAttribute('data-q')); return; }
  });
})();
